// src/app/features/dashboard/widgets/ScarletWell/ScarletWellTotalScoreStyles.js
import { makeStyles } from '@material-ui/core/styles'
import { desktopSideNavWidth } from '../../../../navigation/navigationValues'

const useScarletWellTotalScoreStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === 'dark'
  const surfaceColor = isDark
    ? theme.color.darkerSlateGray
    : theme.palette.base.white
  const questionRowDarkColor = isDark
    ? theme.color.darkSlateGray
    : theme.color.lightGray
  const questionRowLightColor = isDark
    ? theme.color.darkGray
    : theme.color.lighterGray

  return {
    centerPage: {
      minHeight: '100dvh',
      paddingTop: 65,
      paddingLeft: 55,
      [theme.breakpoints.down('sm')]: {
        paddingTop: 60,
        paddingLeft: 0,
      },
    },
    centerPageDrawerOpen: {
      minHeight: '100dvh',
      paddingTop: 65,
      paddingLeft: desktopSideNavWidth,
      transition: 'width 0.4s',
      background: theme.palette.background.default,
    },
    pageContainer: {
      padding: theme.spacing(9.5, 2, 2, 2),
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    stateContainer: {
      minHeight: 320,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardRoot: {
      maxWidth: 940,
      margin: '0 auto',
      borderRadius: '16px',
      boxShadow: isDark
        ? '0 8px 24px rgba(0, 0, 0, 0.35)'
        : '0 6px 16px rgba(0, 0, 0, 0.12)',
      background: surfaceColor,
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
        borderRadius: '0px',
        boxShadow: 'none',
      },
    },
    headerBox: {
      background: theme.color.headerBlue,
      color: theme.palette.base.white,
      padding: theme.spacing(2, 3),
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1.5, 2),
      },
    },
    headerText: {
      color: theme.palette.base.white,
      fontWeight: theme.typography.fontWeightBold,
    },
    contentBox: {
      padding: theme.spacing(4),
      color: theme.palette.text.primary,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2.5, 1.25, 1.5),
      },
    },
    topRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(3),
      },
    },
    scoreArea: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing(3),
    },
    totalLabel: {
      marginRight: theme.spacing(2),
      fontWeight: theme.typography.fontWeightBold,
    },
    scoreValueBox: {
      border: `2px solid ${
        isDark ? theme.palette.base.lightGray : theme.palette.base.darkGray
      }`,
      borderRadius: theme.spacing(2),
      padding: theme.spacing(1, 3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    totalScoreLabel: {
      color: isDark ? theme.color.tealLight : theme.color.tealDark,
      fontWeight: theme.typography.fontWeightBold,
    },
    mediumText: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium,
    },
    divider: {
      width: '100%',
      margin: `${theme.spacing(4)}px auto`,
      backgroundColor: theme.palette.base.lightGray,
    },
    tableOuterShell: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginTop: theme.spacing(4),
    },
    tableScoresWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      overflowX: 'auto',
    },
    tableLeftColumn: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      zIndex: 1,
    },
    tableScoreColumn: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
      minWidth: 60,
    },
    tableHeaderCell: {
      height: 90,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(1),
    },
    tableHeaderEmpty: {
      height: 90,
    },
    tableDateText: {
      transform: 'rotate(-60deg)',
      transformOrigin: 'top',
    },
    tableCell: {
      padding: theme.spacing(1.5, 2),
      display: 'flex',
      alignItems: 'center',
      minHeight: 52,
    },
    tableCellCenter: {
      padding: theme.spacing(1.5, 2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 52,
    },
    tableCellAnswer: {
      fontWeight: theme.typography.fontWeightBold,
    },
    oddRow: {
      backgroundColor: questionRowDarkColor,
    },
    evenRow: {
      backgroundColor: questionRowLightColor,
    },
    categoryText: {
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})

export default useScarletWellTotalScoreStyles
